import styled from 'styled-components';

export const LabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-s);

  > label {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    cursor: pointer;
    
    > input {
      margin: unset; !important;
    }
  }
`;

export const ColumnType = styled.span`
  color: #bbb;
  font-size: 12px;
`;

export const SelectedButton = styled.button`
  border: 1px solid #ddd;
  height: 33px;
  padding: 0 10px;
  background: var(--color-interface-neutral-light);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;

  > b {
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > ${ColumnType} {
    margin-left: 5px;
  }

  > span:last-child {
    font-weight: 600;
    line-height: 1;
    text-shadow: 0 1px 0 var(--color-interface-neutral-light);
    margin-left: 5px;
    font-size: 16px;
    color: #bbb;

    :hover {
      color: #888;
    }
  }
`;

export const SavedQueryConfigurationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
